$.fn.DuotoneHover = function() {
  let self = this

  if (self.data('duotone-hover')) {
    return self.data('duotone-hover')
  }

  return function() {
    let picture = self.find('.picture').clone()
    self.append(picture)
    self.data('duotone-hover', self)
    return self
  }()
}
